import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from "./components/ScrollToTop";

// Import Layoutu
import Layout from "./components/Layout";

// Eager load HomePage for LCP
import HomePage from "./pages/HomePage";

// Lazy load other pages
const CarListPage = lazy(() => import("./pages/CarListPage"));
const CarDetailPage = lazy(() => import("./pages/CarDetailPage"));
const AboutUsPage = lazy(() => import("./pages/AboutUsPage"));
const SoldCarsPage = lazy(() => import("./pages/SoldCarsPage"));
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicyPage"));
const OldListingRedirect = lazy(() => import("./pages/OldListingRedirect"));

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Suspense fallback={
          <div className="flex items-center justify-center min-h-screen bg-white">
            <div className="w-16 h-16 border-4 border-red-100 border-t-red-600 rounded-full animate-spin"></div>
          </div>
        }>
          <Routes>
            {/* Layout z /components/ */}
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />

              {/* Nowe polskie ścieżki */}
              <Route path="ogloszenia" element={<CarListPage />} />
              <Route path="ogloszenia/:slug" element={<CarDetailPage />} />
              <Route path="sprzedane" element={<SoldCarsPage />} />
              <Route path="sprzedane/:slug" element={<CarDetailPage />} />

              {/* Przekierowania ze starych ścieżek (SEO) */}
              <Route path="listings" element={<Navigate to="/ogloszenia" replace />} />
              <Route path="listings/:id" element={<OldListingRedirect />} />
              <Route path="sprzedane/listings/:id" element={<OldListingRedirect />} />

              {/* Strony statyczne */}
              <Route path="o-nas" element={<AboutUsPage />} />
              <Route path="polityka-prywatnosci" element={<PrivacyPolicyPage />} />

            </Route>
          </Routes>
        </Suspense>
      </Router>
    </HelmetProvider>
  );
}

export default App;
